"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const addOn_1 = require("../../../model/entity/addOn");
const helper_1 = require("../../utils/helper");
const vessel_rate_helper_1 = require("../vessel-helper/vessel-rate-helper");
function getPromoDiscountAmount(promo, boatListPrice) {
    if (promo.percentageBased) {
        return (promo.amount / 100) * boatListPrice;
    }
    else {
        return promo.amount;
    }
}
exports.getPromoDiscountAmount = getPromoDiscountAmount;
function getDurationTypeForCalcService(charterDuration) {
    let returnHours = null;
    switch (charterDuration) {
        case 4:
            returnHours = 4;
            break;
        case 8:
            returnHours = 8;
            break;
        default:
            returnHours = 0;
            break;
    }
    return returnHours;
}
exports.getDurationTypeForCalcService = getDurationTypeForCalcService;
function generateDiscountPromoOnCharter(charter, promo) {
    const boatListPrice = vessel_rate_helper_1.getBoatCaptCrewTotalFromOriginalRates(charter.originalRates, getDurationTypeForCalcService(charter.duration), charter.duration);
    const promoDiscountAmount = getPromoDiscountAmount(promo, boatListPrice);
    const promoWithDiscountAmount = Object.assign(Object.assign({}, promo), { promoDiscountAmount: promoDiscountAmount });
    charter.pricingMetaData.promoCode = promoWithDiscountAmount;
    return charter;
}
exports.generateDiscountPromoOnCharter = generateDiscountPromoOnCharter;
function getExtraGuestTotalFromPricingMetaData(pricingMetaData, type, includeMarkup = false) {
    if (pricingMetaData.addOns) {
        let extraGuestAddOn = pricingMetaData.addOns.filter(x => x.name === addOn_1.DefinedAddOnType.EXTRA_GUEST_FEE);
        if (extraGuestAddOn.length) {
            return getAddOnsTotal(extraGuestAddOn, type, includeMarkup);
        }
        return 0;
    }
    else {
        return 0;
    }
}
exports.getExtraGuestTotalFromPricingMetaData = getExtraGuestTotalFromPricingMetaData;
function getAddOnsTotalFromPricingMetaData(pricingMetaData = {}, type, includeMarkup = false) {
    if (pricingMetaData.addOns) {
        return getAddOnsTotal(pricingMetaData.addOns, type, includeMarkup);
    }
    else {
        return 0;
    }
}
exports.getAddOnsTotalFromPricingMetaData = getAddOnsTotalFromPricingMetaData;
function getAddOnsTotal(addOns = [], type, includeMarkup = false) {
    const total = addOns.reduce((acc, curr) => {
        if (!curr ||
            (curr.required && type === 'optional') ||
            (!curr.required && type === 'required') ||
            curr.quantity === 0)
            return acc;
        return acc + getAddOnCost(curr, includeMarkup);
    }, 0);
    return helper_1.roundToNearestCent(total);
}
exports.getAddOnsTotal = getAddOnsTotal;
function getAddOnCost(addOn, includeMarkup = false) {
    const markup = includeMarkup ? 1 + (addOn.markupPercentage || 0) : 1;
    return helper_1.roundToNearestCent(addOn.price * markup * addOn.quantity);
}
exports.getAddOnCost = getAddOnCost;
// TERM CHARTER
function getOptionalAddOnsTotal(optionalAddOns = []) {
    return optionalAddOns.reduce((acc, curr) => acc + curr.price * curr.quantity, 0);
}
exports.getOptionalAddOnsTotal = getOptionalAddOnsTotal;
function getTermTotalPrice(termCharterPricing, includeOptionalAddOns = true) {
    let total = termCharterPricing.totalDue;
    const hasOptionalAddOns = Array.isArray(termCharterPricing.optionalAddOns) &&
        termCharterPricing.optionalAddOns.length > 0;
    if (includeOptionalAddOns && hasOptionalAddOns) {
        total += getOptionalAddOnsTotal(termCharterPricing.optionalAddOns);
    }
    return total;
}
exports.getTermTotalPrice = getTermTotalPrice;
function getTermCharterDateCount(dateStart, dateEnd) {
    const start = new Date(dateStart);
    const end = new Date(dateEnd);
    const timeDiff = Number(end - start) || 0;
    const dayCount = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    return dayCount;
}
exports.getTermCharterDateCount = getTermCharterDateCount;
